import { Toast, Notify, Dialog } from 'vant'
import {loadingText ,messageDuration, title} from '@/config'
import pageLoading from '@/components/pageLoading/index.js'
import {setStorage, getStorage, removeStorage} from '@/libs/Storage'
const install = (Vue) => {
    Vue.prototype.$baseAccessToken = () => {
        return '';
    }

    Vue.prototype.$requestLoading = pageLoading;

    Vue.prototype.$baseTitle = title;

    /* 全局加载层 */
    Vue.prototype.$baseNotify = (text='', type=false, index=0) => {
        let loading = {
            message: text,
            forbidClick: true,
            icon:"warning"
        };
        if(type !== false){
            loading.type = type;
        }
        return Toast(loading)
    }

    /* 全局加载层 */
    Vue.prototype.$baseLoading = (text=loadingText, index=0) => {
        let loading = {
            message: text,
            forbidClick: true,
            loadingType: 'spinner',
        };
        if(index) loading.spinner = 'vab-loading-type' + index;
        return Toast.loading(loading)
    }

    /**
     * @description 消息提示
     * @param msg
     * @param type error|success|warning|
     */ 
    Vue.prototype.$baseMessage = (message, type="success") => {
        let color = '#ffffff';
        let background = '#1989fa';
        if(type == 'success'){
            background = 'var(--theme-color)';
        }
        if(type == 'error'){
            background = 'var(--error-color)';
        }
        if(type == 'warning'){
            background = '#ff976a';
        }

        Notify({
            message,
            type,
            color,
            background,
            dangerouslyUseHTMLString: true,
            duration: messageDuration,
        })
    }

    Vue.prototype.$baseAlert = (content='', title='', callback) => {
        let options= {
            message: content,
            theme: 'round-button',
            confirmButtonColor: 'var(--theme-color)',
        }
        if(title){
            options.title = title
        }

        let obj = Dialog.alert(options).then(() => {
            obj.confirm = callback()
        });
    }

    /**
     * 通用请求并跳转方法
     * @param {Object} options - 配置对象
     * @param {string} options.url - 跳转地址
     * @param {Function} options.apiFunc - 接口函数
     * @param {Object} options.params - 请求参数
     * @param {boolean} [options.needJump=true] - 是否需要跳转，默认true
     * @param {string} [options.loadingText] - 加载提示文字
     * @param {string} [options.successMsg] - 成功提示文字
     * @param {string} [options.errorMsg] - 错误提示文字
     * @returns {Promise} 返回接口响应结果
     */
    // Vue.prototype.$requestAndRedirect = async function(options) {
    //     const { 
    //         url, 
    //         apiFunc, 
    //         params, 
    //         needJump = true,
    //         loadingText = '处理中...',
    //         successMsg,
    //         errorMsg = '请求失败，请重试',
    //         name,selectedId
    //     } = options;
        
    //     let loading = null;
    //     try {
    //         // 显示加载提示
    //         if(loadingText) {
    //             loading = this.$baseLoading(loadingText);
    //         }
    //         // 根据name值存储selectedId到对应的Vuex数组
    //             if(selectedId !== undefined && selectedId !== null) {
    //             if(name === 'download') {
    //                 const currentArray = [...this.$store.state.common.downLoadSelectedArray];
    //                 if(!currentArray.includes(selectedId)) {
    //                 this.$store.commit('common/downLoadSelectedArray', [...currentArray, selectedId]);
    //                 setStorage('downLoadSelectedArray',[...currentArray, selectedId],'local')
    //                 }
    //             } else if(name === 'product') {
    //                 const currentArray = [...this.$store.state.common.productSelectedArray];
    //                 if(!currentArray.includes(selectedId)) {
    //                 this.$store.commit('common/productSelectedArray', [...currentArray, selectedId]);
    //                  setStorage('productSelectedArray',[...currentArray, selectedId],'local')
    //                 }
    //             }
    //             }
    //         const res = await apiFunc(params);
    //         // 关闭加载提示
    //         if(loading) loading.clear();
    //         if (res.code !== 200) {
    //             this.$baseMessage(errorMsg || res.msg || '请求失败', 'error');
    //             return res;
    //         }
    //         // 显示成功提示
    //         if(successMsg) {
    //             this.$baseMessage(successMsg, 'success');
    //         }
    //         if (needJump && url) {
    //             if (url.startsWith('http')) {
    //                 // 外部链接
    //                 window.location.href = url;
    //             } else {
    //                 // 内部路由
    //                 this.$router.push(url);
    //             }
    //         }
            
    //         return res;
    //     } catch (error) {
    //         // 关闭加载提示
    //         if(loading) loading.clear();
            
    //         this.$baseMessage(errorMsg || error.message || '请求异常', 'error');
    //         throw error;
    //     }
    // }
}

export default install;